import { computed, type ComputedRef } from 'vue'

const NOVELTY_BADGE_STORAGE_KEY_PREFIX = 'novelty-badge-'

export const ALLOWED_BADGE_PATHS = [
  '/dashboard/report/cash-movements',
  '/dashboard/report/expenses',
  '/dashboard/report/stock'
] as const

function isAllowedPath (path: string): boolean {
  return ALLOWED_BADGE_PATHS.includes(path as typeof ALLOWED_BADGE_PATHS[number])
}

function getStorageKey (path: string): string {
  return `${NOVELTY_BADGE_STORAGE_KEY_PREFIX}${path}`
}

function isValidEnvironment (): boolean {
  return typeof window !== 'undefined'
}

function setBadgeState (path: string, value: 'true' | 'false'): void {
  if (!isValidEnvironment() || !isAllowedPath(path)) {
    return
  }
  const storageKey = getStorageKey(path)
  localStorage.setItem(storageKey, value)
}

export function shouldShowNoveltyBadge (path: string): boolean {
  if (!isValidEnvironment() || !isAllowedPath(path)) {
    return false
  }
  const storageKey = getStorageKey(path)
  const stored = localStorage.getItem(storageKey)
  return stored !== 'false'
}

export function disableNoveltyBadge (path: string): void {
  setBadgeState(path, 'false')
}

export function enableNoveltyBadge (path: string): void {
  setBadgeState(path, 'true')
}

export function useNoveltyBadge (path: string): {
  shouldShowBadge: ComputedRef<boolean>
  disableBadge: () => void
  enableBadge: () => void
} {
  const shouldShowBadge = computed(() => {
    return shouldShowNoveltyBadge(path)
  })

  function disableBadge (): void {
    disableNoveltyBadge(path)
  }

  function enableBadge (): void {
    enableNoveltyBadge(path)
  }

  return {
    shouldShowBadge,
    disableBadge,
    enableBadge
  }
}
